(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["realoilart-product-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('roa-product-description')) {
    class RoaProductDescription extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.preview = this.querySelector('[data-description-preview]');
        this.content = this.querySelector('[data-description-content]');
        this.toggleButton = this.querySelector('[data-description-toggle]');
        this.moreLabel = this.querySelector('[data-description-more]');
        this.lessLabel = this.querySelector('[data-description-less]');

        if (!this.preview || !this.content || !this.toggleButton) return;

        this.preview.hidden = false;
        this.content.hidden = true;
        this.toggleButton.hidden = false;
        this.toggleButton.addEventListener('click', () => this.toggleDescription());
      }

      toggleDescription() {
        const willExpand = this.toggleButton.getAttribute('aria-expanded') !== 'true';

        this.toggleButton.setAttribute('aria-expanded', String(willExpand));
        this.preview.hidden = willExpand;
        this.content.hidden = !willExpand;
        this.moreLabel.hidden = willExpand;
        this.lessLabel.hidden = !willExpand;
      }
    }

    customElements.define('roa-product-description', RoaProductDescription);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["realoilart-product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('roa-product-share')) {
    class RoaProductShare extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.copyButton = this.querySelector('[data-copy-link]');
        this.nativeButton = this.querySelector('[data-native-share]');
        this.status = this.querySelector('.RoaProductShare__status');
        this.appShareLinks = this.querySelectorAll('[data-app-share]');

        this.copyButton?.addEventListener('click', () => this.copyLink());
        this.appShareLinks.forEach((link) => {
          link.addEventListener('click', (event) => this.openAppShare(event));
        });

        if (typeof navigator.share === 'function') {
          this.nativeButton.hidden = false;
          this.nativeButton.addEventListener('click', () => this.openNativeShare());
        }
      }

      async copyLink() {
        try {
          await this.writeUrlToClipboard();
          this.showStatus(this.dataset.copySuccess);
        } catch (error) {
          this.showStatus(this.dataset.shareUnavailable);
        }
      }

      async openAppShare(event) {
        if (typeof navigator.share === 'function') {
          event.preventDefault();
          await this.openNativeShare();
          return;
        }

        const fallbackMessage = event.currentTarget.dataset.fallbackMessage;

        try {
          await this.writeUrlToClipboard();
          this.showStatus(fallbackMessage);
        } catch (error) {
          this.showStatus(this.dataset.shareUnavailable);
        }
      }

      async writeUrlToClipboard() {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(this.dataset.url);
          return;
        }

        const temporaryField = document.createElement('textarea');
        temporaryField.value = this.dataset.url;
        temporaryField.setAttribute('readonly', '');
        temporaryField.style.position = 'fixed';
        temporaryField.style.opacity = '0';
        document.body.appendChild(temporaryField);
        temporaryField.select();
        const copied = document.execCommand('copy');
        temporaryField.remove();

        if (!copied) throw new Error('Copy command failed');
      }

      async openNativeShare() {
        try {
          await navigator.share({
            title: this.dataset.title,
            url: this.dataset.url
          });
        } catch (error) {
          if (error.name !== 'AbortError') this.showStatus(this.dataset.shareUnavailable);
        }
      }

      showStatus(message) {
        window.clearTimeout(this.statusTimer);
        this.status.textContent = message;
        this.statusTimer = window.setTimeout(() => {
          this.status.textContent = '';
        }, 3500);
      }
    }

    customElements.define('roa-product-share', RoaProductShare);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["roa-footer-share"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('roa-footer-share')){
    class RoaFooterShare extends HTMLElement{
      connectedCallback(){
        if(this.dataset.ready==='true')return;
        this.dataset.ready='true';
        this.status=this.querySelector('.RoaFooterShare__status');
        this.addEventListener('click',event=>{
          const button=event.target.closest('button');
          if(!button||!this.contains(button))return;
          if(button.hasAttribute('data-native-share')){this.nativeShare();return;}
          if(button.hasAttribute('data-copy-link')||button.hasAttribute('data-copy-for'))this.copyLink(button.dataset.message||this.dataset.copySuccess);
        });
        if(typeof navigator.share==='function')this.querySelector('[data-native-share-item]').hidden=false;
      }
      async copyLink(message){
        try{
          if(navigator.clipboard&&window.isSecureContext){await navigator.clipboard.writeText(this.dataset.url);}
          else{
            const field=document.createElement('textarea');field.value=this.dataset.url;field.setAttribute('readonly','');field.style.cssText='position:fixed;opacity:0';document.body.appendChild(field);field.select();const copied=document.execCommand('copy');field.remove();if(!copied)throw new Error('Copy failed');
          }
          this.showStatus(message);
        }catch{this.showStatus(this.dataset.copyError);}
      }
      async nativeShare(){
        try{await navigator.share({title:this.dataset.title,url:this.dataset.url});}
        catch(error){if(error.name!=='AbortError')this.showStatus(this.dataset.copyError);}
      }
      showStatus(message){clearTimeout(this.statusTimer);this.status.textContent=message;this.statusTimer=setTimeout(()=>{this.status.textContent='';},4000);}
      disconnectedCallback(){clearTimeout(this.statusTimer);}
    }
    customElements.define('roa-footer-share',RoaFooterShare);
  }
  } catch(e) { console.error(e); }
})();

})();
